import { graphql, useStaticQuery } from 'gatsby';
import React, { useState, useContext } from 'react';
import { BsList, BsDash, BsPlus } from 'react-icons/bs';
import LocaleLink from './LocaleLink';
import { tr } from '../utils/translations';
import LocaleContext from './LocaleContext';
import { NavStyles } from '../styles/NavStyles';
// import Img from 'gatsby-image';
// import ContactLink from './ContactLink';

// Images
// import navBgJournal from '../assets/images/navBackgrounds/journal-macromenu.jpg';
// import navBgLots from '../assets/images/navBackgrounds/property-lots-macromenu.jpg';
// import navBgCustomBuild from '../assets/images/navBackgrounds/property-custom-build-macromenu.jpg';
import navBgCustomBuildAndLots from '../assets/images/navBackgrounds/property-custom-build-lots-macromenu.jpg';
import navBgStayNow from '../assets/images/navBackgrounds/staynow-macromenu.jpg';
import navBgHideaways from '../assets/images/navBackgrounds/property-hideaways-macromenu.jpg';
import navBgLiveWork from '../assets/images/navBackgrounds/property-live-work-macromenu.jpg';

const HandleToggleExpanded = (expanded, setExpanded) => {
  if (expanded) {
    document.body.classList.remove('expanded', 'nav');
  } else {
    document.body.classList.add('expanded', 'nav');
  }
  setExpanded(!expanded);
};

// Returns a LocaleLink or an AnchorLink inside an <li>
const NavItem = ({
  children,
  to,
  slugs,
  text,
  wrapLi = true,
  backgroundImage,
  setExpanded,
}) => {
  const [subNavExpanded, setSubNavExpanded] = useState(false);
  const itemClassName = `${subNavExpanded ? 'expanded' : ''} ${
    children ? 'hasChildren' : ''
  }`;
  const itemContents = (
    <>
      <LocaleLink to={to} slugs={slugs} onNavigate={() => setExpanded(false)}>
        {backgroundImage && (
          <img src={backgroundImage} className="backgroundImage" alt={text} />
        )}
        <span>{text}</span>
      </LocaleLink>

      {children}

      {children && !subNavExpanded && (
        <BsPlus
          className="toggleSubNavExpanded"
          onClick={() => setSubNavExpanded(true)}
        />
      )}

      {children && subNavExpanded && (
        <BsDash
          className="toggleSubNavExpanded"
          onClick={() => setSubNavExpanded(false)}
        />
      )}
    </>
  );
  if (wrapLi) {
    return <li className={itemClassName}>{itemContents}</li>;
  }
  return <span className="linkWrapper">{itemContents}</span>;
};

// Use this component for journal categories or other subnav items that have their own children
const ExpandableSubNav = ({
  expandKey,
  children,
  text,
  wrapLi = true,
  isThisExpanded,
  expandThis,
}) => {
  const itemClassName = `${isThisExpanded ? 'expanded' : ''} ${
    children ? 'hasChildren noShadow' : ''
  }`;
  // const itemClassName = 'expanded';
  const itemContents = (
    <>
      <span className="title">{text}</span>

      {children}

      {children && !isThisExpanded && (
        <BsPlus
          className="toggleSubNavExpanded"
          onClick={() => expandThis(expandKey)}
        />
      )}

      {children && isThisExpanded && (
        <BsDash
          className="toggleSubNavExpanded"
          onClick={() => expandThis(null)}
        />
      )}
    </>
  );
  if (wrapLi) {
    return <li className={itemClassName}>{itemContents}</li>;
  }
  return <span className="linkWrapper">{itemContents}</span>;
};

const Nav = ({ className }) => {
  const [whichGrandChildExpanded, setWhichGrandChildExpanded] = useState();
  const [expanded, setExpanded] = useState(false);
  const [locale] = useContext(LocaleContext);

  // Static query to grab journal categories & pages
  const navData = useStaticQuery(graphql`
    query {
      journalPages: allSanityGeneralPage(
        filter: { categories: { elemMatch: { _id: { ne: null } } } }
        sort: { fields: _createdAt }
      ) {
        nodes {
          slug {
            ...LocaleStringFields
          }
          name {
            ...LocaleStringFields
          }
          categories {
            id
          }
        }
      }
      journalCategories: allSanityJournalCategory(sort: { fields: order }) {
        nodes {
          id
          slug {
            ...LocaleStringFields
          }
          name {
            ...LocaleStringFields
          }
        }
      }
    }
  `);

  return (
    <NavStyles className={expanded ? `${className} expanded` : className}>
      <LocaleLink to="/">
        <h1 className="logo">MUSA</h1>
      </LocaleLink>
      <ul>
        <NavItem
          to="/vision"
          text={tr('titles', 'vision', locale)}
          setExpanded={setExpanded}
        />
        <NavItem
          to="/#master-plan"
          text={tr('titles', 'masterPlan', locale)}
          setExpanded={setExpanded}
        />
        <NavItem
          to="/property"
          slugs={{ es: 'propiedad' }}
          text={tr('titles', 'liveAtMusa', locale)}
          setExpanded={setExpanded}
        >
          <ul className="subNav property withImages">
            <li>
              <NavItem
                to="/hideaways"
                backgroundImage={navBgHideaways}
                wrapLi={false}
                text={tr('titles', 'hideaways', locale)}
                setExpanded={setExpanded}
              />
            </li>
            <li>
              <NavItem
                to="/live-work"
                slugs={{ es: 'estudios' }}
                wrapLi={false}
                text={tr('titles', 'liveWork', locale)}
                backgroundImage={navBgLiveWork}
                setExpanded={setExpanded}
              />
            </li>
            <li>
              <NavItem
                to="/custom-build-and-lots"
                slugs={{ es: 'casas-a-la-medida-lotes' }}
                wrapLi={false}
                text={tr('titles', 'customBuildAndLots', locale)}
                backgroundImage={navBgCustomBuildAndLots}
                setExpanded={setExpanded}
              />
            </li>
            {/* <li>
              <NavItem
                to="/custom-build"
                slugs={{ es: 'casas-a-la-medida' }}
                wrapLi={false}
                text={tr('titles', 'customBuild', locale)}
                backgroundImage={navBgCustomBuild}
                setExpanded={setExpanded}
              />
            </li>
            <li>
              <NavItem
                to="/lots"
                slugs={{ es: 'lotes' }}
                wrapLi={false}
                text={tr('titles', 'lots', locale)}
                backgroundImage={navBgLots}
                setExpanded={setExpanded}
              />
            </li> */}
          </ul>
        </NavItem>
        <NavItem
          to="/stay-now"
          slugs={{ es: 'visitanos' }}
          text={tr('titles', 'stayNow', locale)}
          setExpanded={setExpanded}
        >
          <ul className="subNav">
            <li>
              <span className="title">{tr('titles', 'bookNow', locale)}</span>
              <NavItem
                to="/casa-musa"
                text={tr('titles', 'laCasa', locale)}
                wrapLi={false}
                setExpanded={setExpanded}
              />
            </li>
            <li className="mobileHidden">
              <span className="title">
                {tr('titles', 'privateResidence', locale)}
              </span>
              <NavItem
                to="/basecamp"
                text={tr('titles', 'basecamp', locale)}
                wrapLi={false}
                setExpanded={setExpanded}
              />
            </li>

            {/* NOTE: temporarily removed */}
            {/* <li>
              <span className="title">
                {tr('titles', 'designHotel', locale)}
              </span>
              <NavItem
                to="/hotelito"
                text={`${tr('titles', 'hotelito', locale)} (${tr(
                  'titles',
                  'comingSoon',
                  locale
                )})`}
                wrapLi={false}
              />
            </li> */}

            <img
              className="navBackground"
              src={navBgStayNow}
              alt={tr('titles', 'shopProperty', locale)}
            />
          </ul>
        </NavItem>

        {/* TODO: top level link should point to category page when implemented */}
        {/* 
          NOTE: use this to link to each category page when implemented
          const slug = category.slug[locale || 'en'];
        */}
        <NavItem
          to="/origins"
          text={tr('titles', 'journal', locale)}
          setExpanded={setExpanded}
        >
          <ul className="subNav expandChildren">
            {navData.journalCategories.nodes.map((category, index) => {
              const name = category.name[locale || 'en'];

              const pagesInCategory = navData.journalPages.nodes.filter(
                (page) => {
                  const pageCategories = page.categories.reduce(
                    (acc, val) => acc.concat([val.id]),
                    []
                  );
                  return pageCategories.includes(category.id);
                }
              );

              return (
                <ExpandableSubNav
                  key={category.id}
                  text={name}
                  expandKey={category.id}
                  isThisExpanded={whichGrandChildExpanded === category.id}
                  expandThis={setWhichGrandChildExpanded}
                >
                  {!pagesInCategory.length && (
                    <span className="placeholder">
                      {tr('titles', 'comingSoon', locale)}
                    </span>
                  )}

                  {pagesInCategory.map((page) => (
                    <NavItem
                      key={`navItem_${index}_${page.slug.en}`}
                      to={`/${page.slug.en}`}
                      slugs={page.slug}
                      text={page.name[locale || 'en']}
                      wrapLi={false}
                      setExpanded={setExpanded}
                    />
                  ))}
                </ExpandableSubNav>
              );
            })}

            {/* Journal nav background, hidden for now  <img
              className="navBackground"
              src={navBgJournal}
              alt={tr('titles', 'journal', locale)}
            /> */}
          </ul>
        </NavItem>

        {/* Link to contact modal (currently unused)
        <li>
          <ContactLink
            text={tr('titles', 'contact', locale)}
            type="contact"
            className="nav"
          />
        </li> */}

        <li>
          {/* NOTE: hack to use Get Site Control contact form (using full reload instead of React) */}
          <a href={locale === 'es' ? '/es/?contacto' : '/?contact'}>
            {tr('titles', 'contact', locale)}
          </a>
        </li>
      </ul>
      <div className="extras">
        <LocaleLink
          to="/faq"
          slugs={{ es: 'preguntas' }}
          onNavigate={() => setExpanded(false)}
        >
          {tr('titles', 'faq', locale)}
        </LocaleLink>
        <LocaleLink to="/vault" onNavigate={() => setExpanded(false)}>
          {tr('titles', 'vault', locale)}
        </LocaleLink>
        <a href="https://instagram.com/findmusa">Instagram</a>
      </div>
      <BsList
        className="toggleExpanded open"
        onClick={() => HandleToggleExpanded(expanded, setExpanded)}
      />
      <BsDash
        className="toggleExpanded close"
        onClick={() => HandleToggleExpanded(expanded, setExpanded)}
      />
    </NavStyles>
  );
};

export default Nav;
